(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v4"] && !Shopify.designMode) return;
  try {
    
 // Array of image URLs
  const images = Array.from(document.querySelectorAll('.change_me')).map(img => img.src);

// Function to loop through the image array and change src and data-src attributes
function changeImage() {
  const imageElement = document.getElementById('change_image');
  let index = 0;

  setInterval(() => {
    // Set both src and data-src attributes to the current image in the array
    imageElement.src = images[index];
    imageElement.setAttribute('data-src', images[index]);

    // Move to the next image in the array
    index = (index + 1) % images.length;
  }, 3000); // 2000ms = 2 seconds
}

// Call the function to start the image rotation
changeImage();


  } catch(e) { console.error(e); }
})();
})();
